import { render, staticRenderFns } from "./PageForbidden.vue?vue&type=template&id=50908b0d&scoped=true"
import script from "./PageForbidden.vue?vue&type=script&lang=js"
export * from "./PageForbidden.vue?vue&type=script&lang=js"
import style0 from "./PageForbidden.vue?vue&type=style&index=0&id=50908b0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50908b0d",
  null
  
)

export default component.exports